module.exports = __webpack_public_path__ + "img/f2.8b0c2314.png";